import * as React from 'react';
import { IValidationConfig, IOperator, clone, QueryBuilderHelper, ComponentHelper, EValidationContext } from '../../helpers';
import { DEFAULT_VALIDATION_RULE_CONFIG } from '../../constants';
import { ValidationItem } from './validation-item';
import { ValidationItemEdit } from './validation-item-edit';
import { NoReferenceableOutputsMessage } from '../';
import { IDropdownOption, Button, ButtonType, MessageBar, MessageBarType } from 'office-ui-fabric-react'

interface IProps {
    validationEditIndex: number;
    editedValidationItem: IValidationConfig;
    value: string;
    operators: IOperator[];
	operatorTypes: string[];
    outputOptions: IDropdownOption[];
    defaultOutputOption?: IDropdownOption;
    validationContext: EValidationContext;
    setValidationEditIndex: (validationEditIndex: number) => void;
    updateEditedValidationItem: (editedValidationItem: IValidationConfig) => void;
    onChange: (value: string) => void;
    
}

export class    Validation extends React.Component<IProps, any> {
    
    private stringifyValidationConfig(config: IValidationConfig[]) {
        return JSON.stringify(config);
    }

    private getControl = (validationConfig: IValidationConfig, index: number): JSX.Element => {
        
        let { validationEditIndex, editedValidationItem, updateEditedValidationItem, setValidationEditIndex, value, outputOptions, defaultOutputOption,
            operators, operatorTypes, validationContext, onChange } = this.props;
        
        if(index === validationEditIndex && editedValidationItem) {
            return (
                <div className="validation-item-wrapper" key={'validation-item-' + index}>
                    <ValidationItemEdit
                        validationItem={editedValidationItem}
                        operators={operators}
                        operatorTypes={operatorTypes}
                        outputOptions={outputOptions}
                        defaultOutputOption={defaultOutputOption}
                        updateEditedValidationItem={updateEditedValidationItem}
                        validationContext={validationContext}
                        saveButtonClick={() => {
                            if(QueryBuilderHelper.canSaveQueryEditor()) {
                                let parsedArray: IValidationConfig[] = ComponentHelper.parseValidationConfig(value);
                                parsedArray[index] = editedValidationItem;
                                setValidationEditIndex(null);
                                onChange(this.stringifyValidationConfig(parsedArray));
                            }
                        }}
                        cancelButtonClick={() => {
                            setValidationEditIndex(null);
                        }}
                    />
                </div>
            );
        }
        else {
            return (
                <div className="validation-item-wrapper" key={'validation-item-' + index}>
                    <ValidationItem 
                        validationItem={validationConfig}
                        canDeleteItem={validationEditIndex === null}
                        canEditItem={validationEditIndex === null}
                        editButtonClick={() => {
                            updateEditedValidationItem(clone(validationConfig));
                            setValidationEditIndex(index);
                        }}
                        deleteButtonClick={() => {
                            let parsedArray: IValidationConfig[] = ComponentHelper.parseValidationConfig(value);
                            parsedArray.splice(index, 1);

                            if(validationEditIndex !== null && validationEditIndex > index) {
                                setValidationEditIndex(validationEditIndex-1);
                            }
                            else {
                                setValidationEditIndex(null);
                            }

                            onChange(this.stringifyValidationConfig(parsedArray));
                        }}
                    />
                </div>
            );
        }

    }

    public addNewValidationConfig(currentConfig: IValidationConfig[]) {
        
        let { onChange, value, setValidationEditIndex } = this.props;

        currentConfig.push({
            ValidationConfig: DEFAULT_VALIDATION_RULE_CONFIG,
            ValidationMessage: '',
            ValidationName: 'New Validation Rule',
            RaiseErrorIfConditionIs: false,
            ApplyIfControlIsEmpty: false
        })

        onChange(this.stringifyValidationConfig(currentConfig));
        
    }

    public render() {

        let { value, validationEditIndex } = this.props;

        if(!this.props.outputOptions.length) {
            return <NoReferenceableOutputsMessage />
        }

        let currentConfig: IValidationConfig[] = ComponentHelper.parseValidationConfig(value);

        let controls = currentConfig.map(this.getControl);

        return (<div className="validation">
            <div>
                {controls}
            </div>
            {validationEditIndex == null && <Button
                buttonType={ ButtonType.icon }
                icon='Add'
                title='Add'
                className={ 'action add-search' }
                onClick={ () => {
                    this.addNewValidationConfig(currentConfig);
                } } 
            />}	
        </div>);
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/validation/validation.tsx